(() => {
  const roots = document.querySelectorAll('[data-kl-product-addons]');
  if (!roots.length) return;

  const routes = (window.KROWN && KROWN.settings && KROWN.settings.routes) || {};
  const addUrl = `${routes.cart_add_url || '/cart/add'}.js`;
  const changeUrl = `${routes.cart_change_url || '/cart/change'}.js`;
  const SYNC_DELAY = 220;
  const COLOR_STORAGE_KEY = 'kl-addon-color-filters';

  function normColor(value) {
    return String(value || '')
      .toLowerCase()
      .replace(/&amp;/g, ' ')
      .replace(/[^a-z0-9]+/g, ' ')
      .replace(/\s+/g, ' ')
      .trim();
  }

  function colorBase(value) {
    return normColor(String(value || '').replace(/\([^)]*\)/g, ' '));
  }

  function colorCode(value) {
    const match = String(value || '').match(/\(([^)]+)\)/);
    return match ? normColor(match[1]) : '';
  }

  function colorMatchScore(selected, candidate) {
    const left = normColor(selected);
    const right = normColor(candidate);
    if (!left || !right) return 0;
    if (left === right) return 100;

    const baseLeft = colorBase(selected);
    const baseRight = colorBase(candidate);
    const codeLeft = colorCode(selected);
    const codeRight = colorCode(candidate);

    if (codeLeft && codeRight && codeLeft === codeRight) return 90;
    if (baseLeft && baseLeft === baseRight) return 80;
    if (codeLeft && codeRight && codeLeft !== codeRight) return 0;

    if (baseLeft && baseRight && (baseRight.includes(baseLeft) || baseLeft.includes(baseRight))) {
      const shorter = baseLeft.length < baseRight.length ? baseLeft : baseRight;
      if (shorter.length < 3) return 0;
      return 60;
    }
    return 0;
  }

  function isColorOptionName(name) {
    const value = String(name || '').toLowerCase();
    return value.includes('color') || value.includes('colour') || value.includes('finish') || value.includes('couleur') || value.includes('colore') || value.includes('farbe');
  }

  function selectedVariantColors(picker) {
    if (!picker) return [];
    const colors = [];
    picker.querySelectorAll('[data-js-product-variant]').forEach((group) => {
      const nameEl = group.querySelector('.product-variant__name');
      if (!isColorOptionName(nameEl && nameEl.textContent)) return;

      const checked = group.querySelector('input.product-variant-value:checked');
      const select = group.querySelector('select[data-js-product-variant-container]');
      const value = checked ? checked.value : (select ? select.value : '');
      if (value && colors.indexOf(value) === -1) colors.push(value);
    });
    return colors;
  }

  function filterColorsFromRequest() {
    const colors = [];
    const params = new URLSearchParams(window.location.search);
    const fromLink = params.get('kl_color');
    if (fromLink) {
      fromLink.split('||').forEach((part) => {
        const value = part.trim();
        if (value && colors.indexOf(value) === -1) colors.push(value);
      });
    }
    if (colors.length) return colors;

    let fromCollection = false;
    try {
      const referrer = new URL(document.referrer);
      fromCollection = referrer.origin === window.location.origin &&
        (referrer.pathname.indexOf('/collections/') !== -1 || referrer.pathname === '/search');
    } catch (e) {
      fromCollection = false;
    }
    if (!fromCollection) return colors;

    try {
      const stored = JSON.parse(sessionStorage.getItem(COLOR_STORAGE_KEY) || '[]');
      if (Array.isArray(stored)) {
        stored.forEach((value) => {
          const color = String(value || '').trim();
          if (color && colors.indexOf(color) === -1) colors.push(color);
        });
      }
    } catch (e) {}
    return colors;
  }

  function scoreCard(card, colors) {
    const colorValue = card.dataset.color || '';
    let best = 0;
    colors.forEach((selected) => {
      if (colorValue) {
        best = Math.max(best, colorMatchScore(selected, colorValue));
        return;
      }
      let options = [];
      try {
        options = JSON.parse(card.dataset.options || '[]');
      } catch (e) {
        options = [];
      }
      options.forEach((option) => {
        best = Math.max(best, colorMatchScore(selected, option));
      });
      best = Math.max(best, colorMatchScore(selected, card.dataset.variantTitle || ''));
    });
    return best;
  }

  async function getCart() {
    const res = await fetch('/cart.js', { credentials: 'same-origin' });
    if (!res.ok) throw new Error('Cart fetch failed');
    return res.json();
  }

  async function postJson(url, body) {
    const res = await fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify(body)
    });
    const data = await res.json().catch(() => ({}));
    if (!res.ok || data.status === 422) {
      throw new Error(data.description || data.message || 'Cart update failed');
    }
    return data;
  }

  function findItem(cart, variantId) {
    const id = Number(variantId);
    return (cart.items || []).find((item) => Number(item.variant_id) === id);
  }

  function setCardUI(card, qty) {
    const addBtn = card.querySelector('[data-kl-addon-add]');
    const stepper = card.querySelector('[data-kl-addon-stepper]');
    const qtyEl = card.querySelector('[data-kl-addon-qty]');
    if (!addBtn || !stepper || !qtyEl) return;

    // Don't overwrite while the shopper is typing
    if (document.activeElement === qtyEl) return;

    const hasQty = Number(qty) > 0;
    addBtn.hidden = hasQty;
    stepper.hidden = !hasQty;
    qtyEl.value = String(hasQty ? qty : 1);
    card.dataset.qty = hasQty ? String(qty) : '0';
    document.dispatchEvent(new CustomEvent('kl:addons-changed', { bubbles: true }));
  }

  function getCardQty(card) {
    const qtyEl = card.querySelector('[data-kl-addon-qty]');
    if (qtyEl && document.activeElement === qtyEl) {
      const typed = parseInt(qtyEl.value, 10);
      if (!Number.isNaN(typed)) return Math.max(0, Math.min(999, typed));
    }
    const stored = Number(card.dataset.qty);
    if (!Number.isNaN(stored)) return stored;
    const stepper = card.querySelector('[data-kl-addon-stepper]');
    if (stepper && !stepper.hidden && qtyEl) {
      const val = parseInt(qtyEl.value, 10);
      return Number.isNaN(val) ? 0 : val;
    }
    return 0;
  }

  async function refreshThemeCart(openDrawer) {
    if (typeof window.refreshCart === 'function' && document.getElementById('AjaxCartForm')) {
      if (openDrawer) {
        window.refreshCart();
        return;
      }
    }

    try {
      const res = await fetch('?section_id=helper-cart');
      const text = await res.text();
      const doc = new DOMParser().parseFromString(text, 'text/html');
      const formSource = doc.getElementById('AjaxCartForm');
      const subtotalSource = doc.getElementById('AjaxCartSubtotal');
      const cartItems = document.getElementById('AjaxCartForm');
      if (formSource && cartItems) {
        cartItems.innerHTML = formSource.innerHTML;
        if (typeof cartItems.ajaxifyCartItems === 'function') cartItems.ajaxifyCartItems();
        document.querySelectorAll('[data-header-cart-count]').forEach((el) => {
          const count = cartItems.querySelector('[data-cart-count]');
          if (count) el.textContent = count.textContent;
        });
      }
      const subtotalTarget = document.getElementById('AjaxCartSubtotal');
      if (subtotalSource && subtotalTarget) {
        subtotalTarget.innerHTML = subtotalSource.innerHTML;
      }
    } catch (e) {
      console.warn('[KL add-ons] theme cart refresh failed', e);
    }
  }

  function initRoot(root) {
    const viewport = root.querySelector('[data-kl-addon-viewport]');
    const track = root.querySelector('[data-kl-addon-track]');
    const cards = Array.from(root.querySelectorAll('[data-kl-addon-card]'));
    if (!track || !cards.length) {
      root.classList.remove('kl-pad--pending');
      return;
    }

    const prev = root.querySelector('[data-kl-addon-prev]');
    const next = root.querySelector('[data-kl-addon-next]');
    const pendingTimers = new WeakMap();
    const pendingPromises = new WeakMap();
    let suppressExternalSync = 0;

    function visibleCards() {
      return cards.filter((card) => !card.hidden);
    }

    function cardStep() {
      const card = visibleCards()[0] || cards[0];
      if (!card || !viewport) return 120;
      const styles = window.getComputedStyle(track);
      const gap = parseFloat(styles.columnGap || styles.gap) || 0;
      return card.getBoundingClientRect().width + gap;
    }

    const picker = (root.closest('product-page') || document).querySelector('[data-main-product-variants]');
    let userPickedVariant = false;
    let filterReady = false;

    function activeColors() {
      const variantColors = selectedVariantColors(picker);
      const requestColors = filterColorsFromRequest();
      const variantInUrl = new URLSearchParams(window.location.search).has('variant');
      if (userPickedVariant || variantInUrl) {
        return variantColors.length ? variantColors : requestColors;
      }
      if (requestColors.length) return requestColors;
      return variantColors;
    }

    function applyColorFilter() {
      const colors = activeColors();
      const max = Number(root.dataset.max) || 8;

      if (!colors.length) {
        const bestByProduct = new Map();
        cards.forEach((card, index) => {
          const key = card.dataset.productId || card.dataset.variantId || `card-${index}`;
          const preferred = card.dataset.preferred === 'true';
          const current = bestByProduct.get(key);
          if (!current) {
            bestByProduct.set(key, { card, index, preferred });
          } else if (preferred && !current.preferred) {
            bestByProduct.set(key, { card, index: current.index, preferred: true });
          }
        });
        const winners = new Set(
          Array.from(bestByProduct.values())
            .sort((a, b) => a.index - b.index)
            .slice(0, max)
            .map((winner) => winner.card)
        );
        cards.forEach((card) => {
          card.hidden = !winners.has(card);
        });
      } else {
        const bestByProduct = new Map();
        cards.forEach((card, index) => {
          const score = scoreCard(card, colors);
          card.hidden = true;
          if (score <= 0) return;
          const key = card.dataset.productId || `card-${index}`;
          const available = card.dataset.available === 'true';
          const current = bestByProduct.get(key);
          if (!current || score > current.score || (score === current.score && available && !current.available)) {
            bestByProduct.set(key, { card, score, available, index });
          }
        });
        Array.from(bestByProduct.values())
          .sort((a, b) => a.index - b.index)
          .slice(0, max)
          .forEach((winner) => {
            winner.card.hidden = false;
          });
      }

      const visible = visibleCards().length;
      root.hidden = visible === 0;
      root.classList.remove('kl-pad--pending');
      if (prev) prev.hidden = visible < 2;
      if (next) next.hidden = visible < 2;
      if (viewport) viewport.scrollLeft = 0;
      updateNav();
      document.dispatchEvent(new CustomEvent('kl:addons-changed', { bubbles: true }));
    }

    function updateNav() {
      if (!viewport || (!prev && !next)) return;
      const maxScroll = Math.max(0, viewport.scrollWidth - viewport.clientWidth - 1);
      if (prev) prev.disabled = viewport.scrollLeft <= 1;
      if (next) next.disabled = viewport.scrollLeft >= maxScroll;
    }

    function scrollByCard(direction) {
      if (!viewport) return;
      viewport.scrollBy({ left: direction * cardStep(), behavior: 'smooth' });
    }

    if (prev) prev.addEventListener('click', () => scrollByCard(-1));
    if (next) next.addEventListener('click', () => scrollByCard(1));
    if (viewport) {
      viewport.addEventListener('scroll', updateNav, { passive: true });
      window.addEventListener('resize', updateNav);
      updateNav();
    }

    async function syncAll() {
      if (suppressExternalSync > 0) return;
      try {
        const cart = await getCart();
        cards.forEach((card) => {
          if (pendingTimers.has(card) || pendingPromises.has(card)) return;
          const qtyEl = card.querySelector('[data-kl-addon-qty]');
          if (qtyEl && document.activeElement === qtyEl) return;
          const item = findItem(cart, card.dataset.variantId);
          setCardUI(card, item ? item.quantity : 0);
          if (item && item.key) card.dataset.itemKey = item.key;
          else delete card.dataset.itemKey;
        });
      } catch (e) {
        console.warn('[KL add-ons] sync failed', e);
      }
    }

    async function commitCard(card, openDrawer) {
      const variantId = Number(card.dataset.variantId);
      if (!variantId) return;

      const desiredQty = getCardQty(card);
      const previousQty = Number(card.dataset.committedQty || 0);

      try {
        suppressExternalSync += 1;

        if (desiredQty <= 0) {
          if (previousQty > 0) {
            const key = card.dataset.itemKey;
            if (key) {
              await postJson(changeUrl, { id: key, quantity: 0 });
            } else {
              const cart = await getCart();
              const item = findItem(cart, variantId);
              if (item) await postJson(changeUrl, { id: item.key, quantity: 0 });
            }
            delete card.dataset.itemKey;
          }
        } else if (previousQty <= 0 || !card.dataset.itemKey) {
          const added = await postJson(addUrl, {
            id: variantId,
            quantity: desiredQty
          });
          const key =
            (added && added.key) ||
            (added && added.items && added.items[0] && added.items[0].key);
          if (key) card.dataset.itemKey = key;
          else {
            const cart = await getCart();
            const item = findItem(cart, variantId);
            if (item && item.key) card.dataset.itemKey = item.key;
          }
        } else if (desiredQty !== previousQty) {
          await postJson(changeUrl, {
            id: card.dataset.itemKey,
            quantity: desiredQty
          });
        }

        card.dataset.committedQty = String(desiredQty);
        await refreshThemeCart(Boolean(openDrawer && desiredQty > 0));
        document.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true }));
      } catch (e) {
        console.warn('[KL add-ons] action failed', e);
        try {
          const cart = await getCart();
          const item = findItem(cart, variantId);
          setCardUI(card, item ? item.quantity : 0);
          card.dataset.committedQty = item ? String(item.quantity) : '0';
          if (item && item.key) card.dataset.itemKey = item.key;
          else delete card.dataset.itemKey;
        } catch (_) {
          setCardUI(card, previousQty);
          card.dataset.committedQty = String(previousQty);
        }
        alert(e.message || 'Could not update cart. Please try again.');
      } finally {
        suppressExternalSync = Math.max(0, suppressExternalSync - 1);
        pendingPromises.delete(card);
      }
    }

    function queueCommit(card, openDrawer) {
      const existing = pendingTimers.get(card);
      if (existing) clearTimeout(existing);

      const shouldOpen = openDrawer || card.dataset.openDrawer === 'true';
      if (openDrawer) card.dataset.openDrawer = 'true';

      const timer = setTimeout(() => {
        pendingTimers.delete(card);
        const open = card.dataset.openDrawer === 'true';
        delete card.dataset.openDrawer;
        const promise = commitCard(card, open || shouldOpen);
        pendingPromises.set(card, promise);
      }, SYNC_DELAY);

      pendingTimers.set(card, timer);
    }

    function updateCard(card, action) {
      const variantId = Number(card.dataset.variantId);
      if (!variantId) return;

      const qtyEl = card.querySelector('[data-kl-addon-qty]');
      if (qtyEl && document.activeElement === qtyEl) qtyEl.blur();

      if (card.dataset.committedQty === undefined) {
        card.dataset.committedQty = String(getCardQty(card));
      }

      const currentQty = getCardQty(card);
      let nextQty = currentQty;
      let openDrawer = false;

      if (action === 'add') {
        nextQty = Math.max(1, currentQty || 1);
        openDrawer = true;
      } else if (action === 'plus') {
        nextQty = Math.min(999, currentQty + 1);
      } else if (action === 'minus') {
        nextQty = Math.max(0, currentQty - 1);
      }

      // Instant UI — same feel as the main product quantity selector
      setCardUI(card, nextQty);
      queueCommit(card, openDrawer);
    }

    function applyTypedQty(card) {
      const qtyEl = card.querySelector('[data-kl-addon-qty]');
      if (!qtyEl) return;

      if (card.dataset.committedQty === undefined) {
        card.dataset.committedQty = String(getCardQty(card));
      }

      let nextQty = parseInt(qtyEl.value, 10);
      if (Number.isNaN(nextQty) || nextQty < 0) nextQty = 0;
      nextQty = Math.min(999, nextQty);

      setCardUI(card, nextQty);
      queueCommit(card, false);
    }

    root.addEventListener('click', (event) => {
      const card = event.target.closest('[data-kl-addon-card]');
      if (!card) return;
      if (event.target.closest('[data-kl-addon-qty]')) return;
      if (event.target.closest('[data-kl-addon-add]')) updateCard(card, 'add');
      else if (event.target.closest('[data-kl-addon-plus]')) updateCard(card, 'plus');
      else if (event.target.closest('[data-kl-addon-minus]')) updateCard(card, 'minus');
    });

    root.addEventListener('focusin', (event) => {
      const qtyEl = event.target.closest('[data-kl-addon-qty]');
      if (!qtyEl) return;
      // Select so shoppers can type a new number immediately
      requestAnimationFrame(() => qtyEl.select());
    });

    root.addEventListener('keydown', (event) => {
      const qtyEl = event.target.closest('[data-kl-addon-qty]');
      if (!qtyEl) return;
      const card = qtyEl.closest('[data-kl-addon-card]');
      if (!card) return;

      if (event.key === 'Enter') {
        event.preventDefault();
        qtyEl.blur();
      } else if (event.key === 'Escape') {
        event.preventDefault();
        const restore = Number(card.dataset.qty);
        qtyEl.value = String(!Number.isNaN(restore) && restore > 0 ? restore : 1);
        qtyEl.blur();
      }
    });

    root.addEventListener('focusout', (event) => {
      const qtyEl = event.target.closest('[data-kl-addon-qty]');
      if (!qtyEl) return;
      const card = qtyEl.closest('[data-kl-addon-card]');
      if (!card) return;
      applyTypedQty(card);
    });

    applyColorFilter();
    filterReady = true;

    if (picker) {
      picker.addEventListener('VARIANT_CHANGE', () => {
        if (!filterReady) return;
        userPickedVariant = true;
        applyColorFilter();
      });
    }

    syncAll();
    document.addEventListener('cart:updated', syncAll);
    document.addEventListener('cart:refresh', syncAll);
  }

  roots.forEach(initRoot);
})();
